module.exports = __webpack_public_path__ + "static/media/brandStrategyTracking-01.ac377e82.png";